export const addAnimationEndListeners = (element, action) => {
  element.addEventListener('webkitAnimationEnd', action)
  element.addEventListener('animationend', action)
}

export const addClickEventListeners = (element, action) => {
  element.addEventListener('mousedown', action)
  element.addEventListener('touchdown', action)
}
